import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { InspectionService, InspectionPluginService } from '../../shared/services/index';
import { ApplicationSubType, Inspection } from '../../shared/models/index';

import { Router, ActivatedRoute, Params } from '@angular/router';
import { BaseModalPageComponent } from '../../base-modal.component';

@Component({
    templateUrl: './view.component.html',
    standalone: false
})
export class InspectionViewPageComponent extends BaseModalPageComponent implements OnInit {
  inspection: Inspection;
  errorMessage: string;
  inspectionId: string;
  returnUrl: string;

  constructor(
    public inspectionService: InspectionService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    location: Location,
    private pluginService: InspectionPluginService
  ) {
    super(location);
  }

  ngOnInit(): void {
    this.initRoute();
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);

      this.inspectionId = id;
      this.returnUrl = params['returnUrl'];
      this.initData();
    });
  }

  cancel(): void {
    if (this.returnUrl) {
      this.router.navigate([this.returnUrl]);
      return;
    }
    if (this.inspection.applicationSubType === ApplicationSubType.ParentInstallation) {
      this.router.navigate([this.inspectionsRoute, this.inspection.id, 'inspections']);
      return;
    }
    this.router.navigate([this.inspectionsRoute, this.inspection.id]);
  }

  initData(): void {
    this.inspectionService.getInspection(this.inspectionId).subscribe((el) => {
      this.inspection = el;
      // what is this line doing ?
      // if we loaded the parts plugin for a specific point, why are we setting it to null here?
      // please explain in comments
      if (this.inspection.parts) {
        this.inspection.parts.point = null;
      }
      this.pluginService.updatePluginsPostUrl(this.inspectionId, this.inspection.plugins);
    });
  }
}
